const ShopReturnMobileIconHome = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2232_11352)" />
      <path
        d="M46.18 51.5757C55.1242 48.6071 60.1296 39.4349 57.7631 30.5823C55.4901 22.0724 47.5656 17.2617 40.0537 17.5357C40.0537 18.3426 40.0537 19.1494 40.0537 20.04C37.1345 18.609 34.3088 17.2312 31.3975 15.8078C34.301 14.3844 37.1345 12.9991 40.0459 11.5757C40.0459 12.4663 40.0459 13.2655 40.0459 14.0952C46.6938 14.1713 52.1195 16.6604 56.1518 21.8136C59.032 25.5053 60.3086 29.745 60.0362 34.3806C59.4913 43.7508 52.4464 49.9468 46.18 51.5757Z"
        fill="white"
      />
      <path
        d="M46.3333 38.375H43V42.5L41.6667 41.5848L40.3333 42.5V38.375H37C36.6333 38.375 36.3333 38.6844 36.3333 39.0625V47.3125C36.3333 47.6906 36.6333 48 37 48H46.3333C46.7 48 47 47.6906 47 47.3125V39.0625C47 38.6844 46.7 38.375 46.3333 38.375ZM30.3333 35.625H39.6667C40.0333 35.625 40.3333 35.3156 40.3333 34.9375V26.6875C40.3333 26.3094 40.0333 26 39.6667 26H36.3333V30.125L35 29.2098L33.6667 30.125V26H30.3333C29.9667 26 29.6667 26.3094 29.6667 26.6875V34.9375C29.6667 35.3156 29.9667 35.625 30.3333 35.625ZM33 38.375H29.6667V42.5L28.3333 41.5848L27 42.5V38.375H23.6667C23.3 38.375 23 38.6844 23 39.0625V47.3125C23 47.6906 23.3 48 23.6667 48H33C33.3667 48 33.6667 47.6906 33.6667 47.3125V39.0625C33.6667 38.6844 33.3667 38.375 33 38.375Z"
        fill="white"
      />
      <path
        d="M36.4999 53.0148C36.4999 53.3905 36.4999 53.7462 36.4999 54.1069C36.4999 54.4576 36.3308 54.5979 35.9049 54.5979C35.2912 54.5979 34.6775 54.6029 34.0637 54.5979C33.688 54.5979 33.5064 54.4526 33.5064 54.152C33.5001 53.7763 33.5064 53.4056 33.5064 53.0148C30.3375 53.0148 27.1874 53.0148 24.006 53.0148C24.006 53.3805 24.006 53.7462 24.006 54.1069C24.006 54.4576 23.8369 54.5929 23.4111 54.5929C22.8099 54.5929 22.2024 54.5929 21.6012 54.5929C21.1754 54.5979 21 54.4576 21 54.127C21 53.11 21 52.093 21 51.076C21 50.7354 21.1754 50.6001 21.6137 50.6001C30.5316 50.6001 39.4433 50.6001 48.3612 50.6001C48.8372 50.6001 49 50.7304 49 51.1061C49 52.108 49 53.105 49 54.1069C49 54.4676 48.8309 54.5979 48.38 54.5979C47.7851 54.5979 47.1901 54.5979 46.6014 54.5979C46.1818 54.5979 46.0127 54.4576 46.0065 54.132C46.0065 53.7663 46.0065 53.4005 46.0065 53.0148C42.8376 53.0148 39.6875 53.0148 36.4999 53.0148Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2232_11352"
          x1="35"
          y1="11"
          x2="34.5455"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6E2EBD" />
          <stop offset="1" stop-color="#4A148C" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default ShopReturnMobileIconHome
